/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  belongsTo,
  attr,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from 'linced-app/models/school';

// Proto: xero.Ledger.
export default class Ledger extends Model {
  declare [Type]: 'xero/ledger';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare code: string;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('boolean', { defaultValue: false })
  declare existsInHero: boolean;

  @attr('boolean', { defaultValue: false })
  declare isChanged: boolean;

  @attr('number', { defaultValue: 0 })
  declare taxType: number;
}
